import { Button, PurchaseButton, SEO } from './page'
import { Row, Testimonial } from './landingPageV2'
import { RichText } from './post'
import { BGVariants, HideOn } from './heroTextSection'
import { ExternalLink } from './page'
import { CssEntry } from './contentfulAttributes'

export interface ProductPage {
  name: string
  title: string
  slug: string
  rows: Row[]
  seo: SEO | null
  contentful_id: string
  __typename: 'ContentfulProductPage'
  createdAt: string
  updatedAt: string
  product: ProductPackageDetail
}

export interface ProductPackagesSection {
  contentful_id: string
  __typename:
    | 'ContentfulProductPackagesSection'
    | 'ContentfulProductPackagesSectionNew'
    | 'ContentfulProductPackagesSectionNewVersion2'
    | 'ContentfulProductPackagesSectionNewVersion3'
    | 'ContentfulProductPackagesSectionNewVersion4'
    | 'ContentfulProductPackagesSectionNewVersion5'
    | 'ContentfulProductPackagesSectionNewVersion6'
  name: string
  backgroundColor: BGVariants
  sectionText: RichText
  productPackageRows: ProductPackageDetail[]
  newSectionText: RichText
  newProductPackagesRows: ProductPackageDetail[]
  codeClasses: string[] | null
  cta: RichText
  css: CssEntry[] | null
  hideOn: HideOn
}

export interface ProductPackageSection {
  __typename:
    | 'ContentfulProductPackageSection'
    | 'ContentfulProductPackageSectionNew'
    | 'ContentfulProductPackageSectionNewVersion2'
    | 'ContentfulProductPackageSectionNewVersion3'
    | 'ContentfulProductPackageSectionNewVersion4'
    | 'ContentfulProductPackageSectionNewVersion5'
    | 'ContentfulProductPackageSectionNewVersion6'
  contentful_id: string
  name: string
  testimonial: Testimonial | null
  text: RichText | null
  button: Button | null
  packageCard: ProductPackageDetail
  packageCardColor: BGVariants
  codeClasses: string[] | null
}

export interface ProductPackageDetail {
  isNewPackage: unknown
  contentful_id: string
  __typename: 'ContentfulProductPackageDetail'
  id: string
  title: string
  subtitle: string
  description: string
  priceOverride: string
  sellingPoints: SellingPoint[]
  productPackage: ProductPackage
  cta: PurchaseButton | Button | null
  secondaryCta: ExternalLink
  backgroundColor: string
  discountToken: string
  variant: PackageVariant
  highlightPackage: boolean
  highlightTag: string
  codeClasses: string[] | null
  css: CssEntry[] | null
}

export enum PackageVariant {
  free = 'Free',
  pricePackage = 'Price Package',
  expandedPackage = 'Expanded Package',
  widePackage = 'Wide Package',
}

export interface SellingPoint {
  contentful_id: string
  __typename: 'ContentfulSellingPoint'
  variant?: string
  sellingPoint: string
  sellingPointBody: RichText
}

export interface ProductPackage {
  contentful_id: string
  items: string[]
  __typename: 'ContentfulProductPackage'
  sort: number | null
  planCode: string | null
}
